import React from 'react';
import { CheckCircle, Award, Clock, Users } from 'lucide-react';

const AboutSection = () => {
  const features = [
    { icon: <Award size={32} />, title: 'Premium Quality Materials', description: 'We use only the finest paints and materials for lasting results' },
    { icon: <Users size={32} />, title: 'Expert Craftsmanship', description: 'Our skilled team brings years of experience to every project' },
    { icon: <Clock size={32} />, title: 'Timely Completion', description: 'We respect your time and deliver projects on schedule' },
    { icon: <CheckCircle size={32} />, title: 'Satisfaction Guarantee', description: 'Your complete satisfaction is our top priority' }
  ];

  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About BLS Paints</h2>
          <p className="section-subtitle">Your Vision, Our Expertise</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p className="body-large">
              At BLS Paints, we believe that every space has a story waiting to be told. With over 15 years of experience in the paint and renovation industry, we've transformed hundreds of homes and commercial spaces into beautiful, inspiring environments.
            </p>
            <p className="body-regular">
              Our commitment to excellence goes beyond just applying paint to walls. We're passionate about understanding your vision and bringing it to life with precision, care, and attention to detail. Whether it's a complete home renovation or a simple color refresh, we approach every project with the same dedication to quality and customer satisfaction.
            </p>
            <p className="body-regular">
              Just as a master painter transforms a blank canvas, we transform your spaces into timeless masterpieces that reflect your personality and style.
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="about-values">
          <h3 className="values-title">Our Promise to You</h3>
          <p className="body-regular">
            We don't just apply paint; we craft experiences that last a lifetime. Your vision, our expertise—together, we create spaces that inspire.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;